import { collection, addDoc } from 'firebase/firestore';
import { db } from '../firebase';

const parseTabData = (tabData) => {
  const lines = tabData.split('\n');
  console.log('Total lines:', lines.length);
  
  return lines
    .filter(line => line.trim()) // Remove empty lines
    .slice(1) // Skip header line
    .map(line => {
      const [styleNo, brand, description, cogs] = line.split(',').map(item => item.trim());
      console.log('Parsing line:', { styleNo, brand, description, cogs });
      
      // Only create product if we have valid data
      if (styleNo && brand) {
        return {
          styleNo: styleNo,
          brand: brand,
          description: description || '',
          cogs: cogs ? parseFloat(cogs) : null,
          createdAt: new Date(),
          updatedAt: new Date()
        };
      }
      return null;
    })
    .filter(product => product !== null); // Remove any invalid products
};

export const uploadProductsToFirebase = async (tabData) => {
  try {
    console.log('Starting to parse data...');
    const products = parseTabData(tabData);
    console.log(`Parsed ${products.length} valid products`);

    const productsRef = collection(db, 'products');
    let uploadedCount = 0;

    for (const product of products) {
      try {
        await addDoc(productsRef, product);
        uploadedCount++;
        console.log(`Uploaded ${uploadedCount}/${products.length}: ${product.styleNo}`);
      } catch (error) {
        console.error(`Failed to upload ${product.styleNo}:`, error);
      }
    }

    console.log(`Upload complete! Successfully uploaded ${uploadedCount} products`);
    return true;
  } catch (error) {
    console.error('Upload failed:', error);
    throw error;
  }
}; 